<template>
  <v-container
      fluid
  >
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>

          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :no-results-text="$t('No matching data found')"
            :no-data-text="$t('No data available')"
            :footer-props="{'items-per-page-options': [10, 20, 50, -1]}"
            @click:row="toPatient"
          >
            <template v-slot:item.birth_date="{ item }">
              <span>{{ myFormatDate(item.birth_date) }}</span>
            </template>

            <template v-slot:top>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('Search')"
                    single-line
                    hide-details
                    clearable
                    class="ml-3"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="filter_surgeon"
                    :label="$t('Surgeon')"
                    :items="surgeons"
                    clearable
                  ></v-select>
                </v-col>                        
                <v-col cols="6" class="text-right">
                  <v-btn
                    @click.stop="exportxls"
                    color="secondary"
                    class="mr-3"
                    bottom
                  >
                    <v-icon left>mdi-application-export</v-icon> {{ $t('Export xls') }}
                  </v-btn>
                  <v-btn
                    link
                    :to="{ name: 'patient'}"
                    color="secondary"
                    class="mr-3"
                    bottom
                  >
                    <v-icon left>mdi-plus</v-icon> {{ $t('Add patient') }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
//import ItemDialog from '@/components/MasterFileDialog'
import { DateTime, formatDate } from '@/lib/helpers'
import _ from 'lodash'
import {fetchList} from '@/lib/helpers'

export default {
  data: () => ({
    items: [],
    totalItems: 10,
    loading: true,
    options: {
        itemsPerPage: 10,
    },
    search: '',
    surgeons: [],
    filter_surgeon: null,
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('Name'), value: 'full_name', align: 'left', sortable: true, width: '15%' },
        { text: this.$t('Gender'), value: 'gender', align: 'left', sortable: true, width: '10%' },
        { text: this.$t('Date of birth'), value: 'birth_date', align: 'left', sortable: true, width: '15%' },
        { text: this.$t('Program'), value: 'program', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('Province'), value: 'province', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('Municipality'), value: 'municipality', align: 'left', sortable: true, width: '15%' },
        { text: this.$t('Village / town'), value: 'village_or_town', align: 'left', sortable: true, width: '15%' },
        { text: this.$t('Status'), value: 'status', align: 'left', sortable: false, width: '15%' },
      ]
    },
  },
  watch: {
    '$i18n.locale': function () {
        this.fetchItems()
    },
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    search() {
      this.fetchItems()
    },
    filter_surgeon() {
      this.fetchItems()
    },
  },
  methods: {
    exportxls() {
      this.dlExportXls()
    },
    dlExportXls() {
      this.$store.dispatch('session/showLoader')
      ApiService.dl(`/patients/export-xls`, {   
            params: {
              filter: {
                query: this.search,
                surgeon: this.filter_surgeon
              },
            },  
            responseType : 'blob'
      }).then(blob => {
        this.openFile(blob, 'tab', 'export.xlsm')
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })    
    },
    openFile(blob, openas = 'dl', fileName = null) {
        if (openas == 'dl' || !openas) {
            // download pdf -----------------------------
            var fileURL = window.URL.createObjectURL(new Blob([blob]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
        }        
        if (openas == 'tab') {
            // opens in new tab
            let url = window.URL.createObjectURL(blob)
            window.open(url, '_blank')
        }
    },    
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/patients', this.options, {
        params: {
          filter: {
            query: this.search,
            surgeon: this.filter_surgeon
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_patients', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_patients')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
    toPatient(item) {
      this.$router.push({
        name: 'patient',
        params: {
          patientId: item.id,
        },
      })
    },
    myFormatDate(isoDate) {
      return formatDate(DateTime.fromISO(isoDate))
    },
  },
  created() {
    this.$store.dispatch('session/title', 'Patients')
    fetchList(this, 'surgeons', '/master-files/get-list', 'master_file_type_tag', 'surgeon')
  },
}
</script>

<style scoped>

</style>


